import { fileService } from '@/services/file.service'
import type { PreparedUploadInput, UploaderCallbacks, UploaderStrategyResult, UploadStrategy } from './uploader'

/** The existing single-presigned-PUT transport, unchanged in behavior — now a `UploadStrategy` against an already-created File. */
export const singlePutUploader: UploadStrategy = {
	execute: async (input: PreparedUploadInput, callbacks: UploaderCallbacks): Promise<UploaderStrategyResult> => {
		// Binds the presigned URL to these exact bytes, so S3 verifies the upload —
		// unchanged from the legacy combined route's guarantee.
		const { uploadUrl } = await fileService.requestUploadUrlForFile(input.fileId, input.file)
		callbacks.onFileCreated(input.fileId)
		// The PUT must send the SAME type the URL was signed with. `putToS3` otherwise
		// defaults to `body.type`, which is the empty string Safari gives a `.psd` —
		// and S3 rejects the signature mismatch.
		// The signal reaches the transfer and nothing else: the presign and the
		// confirm are short server calls whose abort would leave the upload in a
		// less recoverable state than letting them finish.
		await fileService.putToS3(uploadUrl, input.file, callbacks.onProgress, {
			contentType: input.contentType,
			signal: input.signal,
		})
		callbacks.onConfirming()
		const file = await fileService.confirmUpload(input.fileId, input.classify)
		return { kind: 'completed', file }
	},
}
